import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as React from 'react';

import { getCustomBackground } from './helpers';
import * as styles from './RegionalBackground.css';

export interface IRegionalBackgroundProps {
  jsonQuery: IJsonQuery;
}

export class RegionalBackground extends React.Component<IRegionalBackgroundProps> {
  public render() {
    return (
      <div
        className={styles['container']}
        style={{
          backgroundImage: `url(${getCustomBackground(this.props.jsonQuery)})`,
        }}
      />
    );
  }
}
